//libs
/// <reference path="jquery/jquery.d.ts" />
/// <reference path="datatables/datatables.d.ts" />
/// <reference path="bootstrap/bootstrap.d.ts" />
/// <reference path="bootstrap/bootstrap.v3.datetimepicker.d.ts" />
/// <reference path="moment/moment.d.ts" />
/// <reference path="js-cookie/js-cookie.d.ts" />

//internal classes
/// <reference path="classes/basket.ts" />
/// <reference path="classes/basket_notificator.ts" />

//init
/// <reference path="form.ts" />
/// <reference path="init.datatables.ts" />
/// <reference path="init.tooltip.ts" />
/// <reference path="init.basket.ts" />
/// <reference path="init.summernote.ts" />
/// <reference path="init.bootstrapselect.ts" />
/// <reference path="HtmlHelper.ts"/>
/// <reference path="DataTablesHelper.ts"/>

$.views.settings.delimiters("<%", "%>");

$(document).ready(function () {
    var events:BasketEvents = new BasketEvents();

    events.onDataReceived = (changeMade:boolean) => { BasketNotification.notify(changeMade); };
    events.onLoadingStart = (changeMade:boolean) => { BasketNotification.setLoading(changeMade); };

    var basket:Basket = Basket.instance(events);
});